module.exports = __webpack_public_path__ + "img/logo-bajie-circle.0c96be3e.png";